import { Converter } from '../types/converter';

export const momentOfInertiaConverter: Converter = {
  id: 'momentOfInertia',
  name: 'Moment of Inertia Converter',
  icon: 'RotateCw',
  categories: ['engineering', 'physics'],
  units: [
    // Base SI unit
    { name: 'Kilogram square meter', symbol: 'kg·m²', factor: 1 },
    
    // Metric units
    { name: 'Kilogram square centimeter', symbol: 'kg·cm²', factor: 0.0001 },
    { name: 'Kilogram square millimeter', symbol: 'kg·mm²', factor: 1e-6 },
    { name: 'Gram square centimeter', symbol: 'g·cm²', factor: 1e-7 },
    { name: 'Gram square millimeter', symbol: 'g·mm²', factor: 1e-9 },
    
    // Force-based units
    { name: 'Kilogram-force meter square second', symbol: 'kgf·m²·s', factor: 9.80665 },
    { name: 'Kilogram-force centimeter square second', symbol: 'kgf·cm²·s', factor: 0.000980665 },
    
    // Imperial/US units
    { name: 'Ounce square inch', symbol: 'oz·in²', factor: 1.829004e-5 },
    { name: 'Ounce-force inch square second', symbol: 'ozf·in²·s', factor: 0.007061552 },
    { name: 'Pound square foot', symbol: 'lb·ft²', factor: 0.042140110 },
    { name: 'Pound-force foot square second', symbol: 'lbf·ft²·s', factor: 1.355818 },
    { name: 'Pound square inch', symbol: 'lb·in²', factor: 0.000292641 },
    { name: 'Pound-force inch square second', symbol: 'lbf·in²·s', factor: 0.112984829 },
    { name: 'Slug square foot', symbol: 'slug·ft²', factor: 1.355818 }
  ]
};
